<template>
  <div class="videos-wrapper">
    <b-row>
      <b-col>
        <h3>Virtual Garden Visit</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <p>With hundreds of virtual visits filmed in the 2020/21 lockdowns we continue to add new content to our channels showcasing the wonderful array of gardens that open in the National Garden Scheme.</p>
        <p>We hope that these films inspire you to visit.</p>
      </b-col>
      <b-col
        cols="12"
        class="video-wrapper"
        v-if="garden.videos.length"
      >
        <div v-for="(video, index) in garden.videos" :key="index">
          <iframe
            class="video-iframe"
            :src="`https://www.youtube.com/embed/${video.id}`"
            :title="`Garden Visit #${index}`"
            frameborder="0"
            allowfullscreen />
        </div>
      </b-col>
    </b-row>

  </div>
</template>

<script>

export default {
  name: 'Videos',

  props: {
    garden: Object,
  },
}
</script>

<style lang="scss">
  .video-wrapper {
    display: flex;
    justify-content: center;

    .video-iframe {
      width: 560px;
      height: 315px;
    }
  }
</style>
